import React from "react";
import Container from "../container";
import "./index.scss";

export default function ImageContainer ({src, className = ""}) {
    return <Container className={`product-pages-image-container ${className}`}>
        <img rel="prefetch" src={src}/>
    </Container>
}